import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ImpressumView from '@/views/ImpressumView.vue'
import RuleView from '@/views/RuleView.vue'
import AdminLoginView from '@/views/AdminLoginView.vue'
import AdminDashboardView from '@/views/AdminDashboardView.vue'
import authService from '@/services/AuthService'
import { trackPageview } from '@/analytics/umami'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: ImpressumView
  },
  {
    path: '/rules',
    name: 'rules',
    component: RuleView
  },
  {
    path: '/admin',
    name: 'admin-login',
    component: AdminLoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: AdminDashboardView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Neue Seiten oben starten, Anker (z. B. #datenschutz) unter der Kopfzeile anspringen
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, top: 80, behavior: 'smooth' }
    return { top: 0 }
  }
})

// Route guard for admin routes
router.beforeEach((to, _from, next) => {
  const requiresAuth = to.meta.requiresAuth

  // If route requires auth and user is not authenticated, redirect to login
  if (requiresAuth && !authService.isAuthenticated()) {
    next({ name: 'admin-login', query: { redirect: to.fullPath } })
  }
  // If user is authenticated and tries to access login page, redirect to dashboard
  else if (to.name === 'admin-login' && authService.isAuthenticated()) {
    next({ name: 'admin-dashboard' })
  }
  else {
    next()
  }
})

// Besucherstatistik: jeden Seitenwechsel melden (Admin-Seiten werden ausgelassen)
router.afterEach((to) => {
  trackPageview(to.path)
})

export default router
